import { getV3dProcedures } from '../../v3d-utils/get-v3d-procedures';
import { keyframeGroups } from '../fading/shared-animation-data';

export const pauseGearAnimation = () => {
  getV3dProcedures().pauseAnimations(keyframeGroups.gears);
};
